import classNames from "classnames";
import "./index.css";
import Star from "./Star.tsx";
import { FC, useEffect, useState } from "react";
import { CategoriesService } from "src/services/amazon/categories/categories.service";

interface IProps {
  rating?: number;
  showRating?: boolean;
  oneRating?: boolean;
  starSize?: "sm" | "md" | "lg";
  asin?: string;
}

export const Rating: FC<IProps> = ({
  rating,
  showRating = true,
  oneRating = false,
  starSize,
  asin,
}: IProps) => {
  const computedWidth = `${(rating / 5) * 100}%`;

  const starPositions = [1, 2, 3, 4, 5];

  const [reviewsTotal, setReviewsTotal] = useState<number | null>(null);
  useEffect(() => {
    if (asin) {
      const categoriesService = new CategoriesService();
      categoriesService.getStats(asin).then((result) => {
        setReviewsTotal(result.total);
      });
    }
  }, [asin]);

  return oneRating ? (
    <div className="ratingStarContainer">
      <div className={classNames("rating__stars", starSize)}>
        <div className={classNames("rating-underlay", starSize)}>
          <div className={classNames("rating__star", starSize)}>
            <Star />
          </div>
        </div>

        <div
          className={classNames("rating-overlay", starSize)}
          style={{ width: computedWidth }}
        >
          <div className={classNames("rating__star", starSize)}>
            <Star />
          </div>
        </div>
      </div>

      {showRating && <p className="rating__value heading-3">{rating}</p>}
    </div>
  ) : (
    <div className="rating">
      <div className={classNames("rating__stars", starSize)}>
        <div className={classNames("rating-underlay", starSize)}>
          {starPositions.map((pos) => (
            <div
              key={`underlay-${pos}`}
              className={classNames("rating__star", starSize)}
            >
              <Star />
            </div>
          ))}
        </div>

        <div
          className={classNames("rating-overlay", starSize)}
          style={{ width: computedWidth }}
        >
          {starPositions.map((pos) => (
            <div
              key={`overlay-${pos}`}
              className={classNames("rating__star", starSize)}
            >
              <Star />
            </div>
          ))}
        </div>
      </div>

      {showRating && <p className="rating__value heading-3">{rating}</p>}
      {asin && reviewsTotal !== null && (
        <span className="rating__asin reviews-total">({reviewsTotal})</span>
      )}
    </div>
  );
};
